import { useCountdown, pad } from "../lib/useCountdown";

export default function AnnouncementBar() {
    const { h, m, s } = useCountdown();
    return (
        <div
            data-testid="announcement-bar"
            className="animate-bar-shimmer bg-gradient-to-r from-orange-600 via-amber-500 to-orange-600 text-slate-950"
        >
            <div className="mx-auto flex max-w-7xl flex-col items-center justify-center gap-1 px-4 py-2 text-[11px] font-semibold sm:flex-row sm:justify-between sm:px-6 sm:text-sm">
                <p className="flex items-center gap-2">
                    <span className="relative flex h-2 w-2">
                        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-rose-600 opacity-75" />
                        <span className="relative inline-flex h-2 w-2 rounded-full bg-rose-600" />
                    </span>
                    ✦ FESTIVE OFFER —{" "}
                    <span className="font-extrabold tracking-wide">
                        ONLY ₹199/-
                    </span>{" "}
                    · Instant Access
                </p>
                <p
                    data-testid="countdown-timer"
                    className="font-display font-bold tabular-nums tracking-wide"
                >
                    Sale ends in {pad(h)}:{pad(m)}:{pad(s)}
                </p>
            </div>
        </div>
    );
}
